import { RatingTypesNames } from '@/creditflowresearch/ui/common/constants';

import alignStyles from '@creditflowresearch/uilib/styles/helpers/align.module.scss';

const getColumns = (isDealCmbs: boolean, ratingsMapping: []) => ([
  {
    name: 'class',
    title: 'Class',
    className: alignStyles.alignLeft,
    tooltipContent: 'Class',
    width: 90,
  },
  {
    name: 'currency',
    title: 'CCY',
    className: alignStyles.alignCenter,
    tooltipContent: 'Currency',
    width: 40,
  },
  {
    name: 'sze',
    title: 'SIZE (M)',
    className: alignStyles.alignRight,
    tooltipContent: 'Issue Size in Millions',
    width: 90,
  },
  {
    name: 'wal',
    title: 'WAL',
    className: alignStyles.alignCenter,
    tooltipContent: 'Weighted Average Life',
    width: 70,
  },
  ...(isDealCmbs
      ? [
        {
          name: 'walx',
          title: 'WALX',
          className: alignStyles.alignRight,
          tooltipContent: 'WAL Extended',
          width: 70,
        },
      ]
      : []
  ),
  ...ratingsMapping.reduce((acc, { displayName, abbreviation }) => {
    if (displayName === RatingTypesNames.MS) {
      return acc;
    }
    return [...acc, {
      name: abbreviation,
      title: abbreviation,
      className: alignStyles.alignCenter,
      tooltipContent: `${ displayName === RatingTypesNames.DR ? `${ RatingTypesNames.MS } ${ displayName }` : displayName } Rating`,
      width: 60,
    }];
  }, []),
  {
    name: 'ce',
    title: 'C/E',
    className: alignStyles.alignCenter,
    tooltipContent: 'Credit Enhancement',
    width: 90,
  },
  {
    name: 'LTV',
    title: 'LTV',
    className: alignStyles.alignCenter,
    tooltipContent: 'Loan-To-Value',
    width: 80,
  },
  {
    name: 'TYPE',
    title: 'TYPE',
    className: alignStyles.alignCenter,
    tooltipContent: 'Coupon Type',
    width: 90,
  },
  {
    name: 'BNCH',
    title: 'BNCH',
    className: alignStyles.alignCenter,
    tooltipContent: 'Benchmark',
    width: 90,
  },
  {
    name: 'IPT',
    title: 'IPT',
    className: alignStyles.alignCenter,
    tooltipContent: 'Init. Price Talk',
    width: 90,
  },
  {
    name: 'GDNC',
    title: 'GDNC',
    className: alignStyles.alignCenter,
    tooltipContent: 'Guidance',
    width: 110,
  },
  {
    name: 'SPRD',
    title: 'SPRD',
    className: alignStyles.alignRight,
    tooltipContent: 'Spread',
    width: 110,
  },
  {
    name: 'CPN',
    title: 'CPN',
    className: alignStyles.alignRight,
    tooltipContent: 'Coupon',
    width: 90,
  },
  {
    name: 'YLD',
    title: 'YLD',
    className: alignStyles.alignRight,
    tooltipContent: 'Yield',
    width: 100,
  },
  {
    name: 'PRICE',
    title: 'PRICE',
    className: alignStyles.alignRight,
    tooltipContent: 'Issue Price',
    width: 100,
  },
]);

export default getColumns;
